export enum RegisterState {
  Inactive = 'Inactive',
  Active = 'Active',
  AllowedAction = 'AllowedAction',
  ForbiddenAction = 'ForbiddenAction',
}
